import React, { Fragment } from 'react';
import { translate } from 'react-i18next';
import { Icon } from '../../Common/Icon';
// import { gtmSend } from '../../../helpers';
import cx from '../../../styles';
import Modal from 'react-modal';

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
if (typeof window != 'undefined') {
    Modal.setAppElement('#root');
}

const AuthorRolesModal = (props) => {
    const customStyles = {
        content: {
            top                   : '50%',
            left                  : '50%',
            right                 : 'auto',
            bottom                : 'auto',
            marginRight           : '-50%',
            transform             : 'translate(-50%, -50%)'
        }
    }

    return (
        <Fragment>
            <Modal
                isOpen={props.isModalOpen}
                // onAfterOpen={this.onAfterOpen}
                onRequestClose={() => props.handleRolesClick(false)}
                overlayClassName={"myOverlayClass author-roles-modal-overlay"}
                style={customStyles}
            >
                <div className={cx('author-roles-modal-wrap')}>
                    <div className={cx('user-tags-wrap')}>
                        <span>{props.t('user_tags')}</span>
                        <span onClick={() => props.handleRolesClick(false)}><Icon name="close-regular-black-sm" /></span>
                    </div>
                    <div className={cx('author-roles-wrap')}>
                        {
                            props.userRoles && props.userRoles.isLoading
                            ?
                                <span className={cx("spin-loader")} />
                            :
                                props.userRoles.data && props.userRoles.data.length > 0 &&
                                props.userRoles.data.map((role) => {
                                    return (
                                        <div key={role.id} className={cx('each-role-wrap')}>
                                            <div className={cx('role-tag-wrap')}>
                                                <span className={cx('role-tag')} style={{ borderColor: role.tag_color_code, background: role.tag_color_code}}>{role.tag}</span>
                                                {
                                                    role.button &&
                                                    <a className={cx('apply-btn')} href={role.id === 1 ? 'https://www.parents.vip/influencer/login' : role.button.url} target="_blank" rel="noopener noreferrer">{role.button.label}</a>
                                                }
                                            </div>
                                            <div className={cx('role-desc')}>{role.description}</div>
                                        </div>
                                    )
                                })
                        }
                    </div>
                </div>
            </Modal>
        </Fragment>
	)
}

export default translate()(AuthorRolesModal);